import type * as lazyIndex from './lazyIndex';
import { LazyModule, LazyAction } from 'owa-bundling-light';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "LeftNavLazyActions" */ './lazyIndex'),
    { name: 'LeftNavLazyActions' }
);

export const lazyLoadGroupsList: LazyAction<typeof lazyIndex.loadGroupsList, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.loadGroupsList);

export const lazyUnsubscribeFromGroupUnreadNotifications: LazyAction<
    typeof lazyIndex.unsubscribeFromGroupUnreadNotifications,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.unsubscribeFromGroupUnreadNotifications);
